import { render, staticRenderFns } from "./TermometriaCadastroNovaVersao.vue?vue&type=template&id=31812c79&"
import script from "./TermometriaCadastroNovaVersao.vue?vue&type=script&lang=js&"
export * from "./TermometriaCadastroNovaVersao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports